import { useSolvSelector } from '~/reducers';

const useGetTrackingPropertiesFromState = () => {
  const trackingProperties = useSolvSelector((state) => state.sessionTrackingProperties);
  const newBooking = useSolvSelector((state) => state.newBooking);
  const login = useSolvSelector((state) => state.login);
  const searchPreferences = useSolvSelector((state) => state.searchPreferences);
  return {
    ...trackingProperties,
    accountId: login?.login?.account_id,
    userProfileId: newBooking?.booking?.userProfileId,
    browserLocationAllowed: !!searchPreferences?.browserLocationAllowed,
  };
};

export default useGetTrackingPropertiesFromState;
